// import { Link } from "react-router-dom";
// import { Sparkles, ArrowRight } from "lucide-react";

// export default function Payments() {
//   return (
//     <div>
//       <h1 className="text-3xl font-extrabold text-gray-900">Payments</h1>
//       <p className="text-gray-600 mt-1 mb-6">Live module preview</p>

//       <div className="bg-gray-50 border border-gray-100 rounded-2xl px-6 py-16 flex flex-col items-center text-center">
//         <div className="w-14 h-14 rounded-2xl bg-gradient-to-br from-indigo-500 to-purple-600 flex items-center justify-center mb-6">
//           <Sparkles className="w-6 h-6 text-white" />
//         </div>

//         <h2 className="text-2xl font-extrabold text-gray-900 mb-4">Payments</h2>

//         <p className="text-gray-500 max-w-xl mb-8">
//           This module is part of the ProtoHub MVP scaffold — data schema,
//           workflows and role permissions are wired. Full UI is being rolled
//           out module-by-module across the next releases.
//         </p>

//         <div className="flex flex-wrap items-center justify-center gap-3">
//           <Link
//             to="/app/dashboard"
//             className="bg-white border border-gray-200 text-gray-900 font-semibold text-sm px-5 py-2.5 rounded-xl hover:bg-gray-100 transition"
//           >
//             Innovator Home
//           </Link>
          
//             <a href="#apic-admin"
//             className="flex items-center gap-2 bg-gradient-to-r from-indigo-600 to-purple-600 text-white font-semibold text-sm px-5 py-2.5 rounded-xl hover:opacity-90 transition"
//           >
//             APIC Admin
//             <ArrowRight className="w-4 h-4" />
//           </a>
//         </div>
//       </div>
//     </div>
//   );
// }




import { useState } from "react";
import { Search } from "lucide-react";
import WalletCard from "../components/modules/payments/WalletCard";
import AddMoneyModal from "../components/modules/payments/AddMoneyModal";
import TransactionRow from "../components/modules/payments/TransactionRow";
import transactionsData from "../data/transactionsData";

const filters = ["All", "Credit", "Debit"];

export default function Payments() {
  const [balance, setBalance] = useState(48600);
  const [transactions, setTransactions] = useState(transactionsData);
  const [showAddMoney, setShowAddMoney] = useState(false);
  const [query, setQuery] = useState("");
  const [activeFilter, setActiveFilter] = useState("All");

  const handleConfirmAddMoney = (amount) => {
    setBalance((prev) => prev + amount);
    setTransactions((prev) => [
      {
        id: `TXN-${Math.floor(Math.random() * 90000 + 10000)}`,
        type: "Credit",
        title: "Wallet Top-up",
        reference: "Manual top-up",
        date: "Today",
        method: "UPI",
        amount,
        status: "Completed",
        statusColor: "bg-green-100 text-green-700",
      },
      ...prev,
    ]);
    setShowAddMoney(false);
  };

  const filtered = transactions.filter((t) => {
    const matchesFilter =
      activeFilter === "All" ||
      (activeFilter === "Pending" ? t.status === "Pending" : t.type === activeFilter);
    const matchesQuery =
      t.title.toLowerCase().includes(query.toLowerCase()) ||
      t.reference.toLowerCase().includes(query.toLowerCase());
    return matchesFilter && matchesQuery;
  });

  const totalAdded = transactions
    .filter((t) => t.type === "Credit" && t.status === "Completed")
    .reduce((sum, t) => sum + t.amount, 0);
  const totalSpent = transactions
    .filter((t) => t.type === "Debit" && t.status === "Completed")
    .reduce((sum, t) => sum + t.amount, 0);
  const pendingCount = transactions.filter((t) => t.status === "Pending").length;

  return (
    <div>
      <h1 className="text-3xl font-extrabold text-gray-900">Payments</h1>
      <p className="text-gray-600 mt-1 mb-6">
        Manage your wallet and view your payment history.
      </p>

      <div className="mb-6">
        <WalletCard balance={balance} onAddMoney={() => setShowAddMoney(true)} />
      </div>

      {/* Summary stats */}
      <div className="grid sm:grid-cols-3 gap-4 mb-6">
        <div className="bg-white border border-gray-100 rounded-2xl p-5">
          <p className="text-xs font-semibold text-gray-400 tracking-wide mb-2">TOTAL ADDED</p>
          <p className="text-2xl font-extrabold text-green-600">
            ₹{totalAdded.toLocaleString("en-IN")}
          </p>
        </div>
        <div className="bg-white border border-gray-100 rounded-2xl p-5">
          <p className="text-xs font-semibold text-gray-400 tracking-wide mb-2">TOTAL SPENT</p>
          <p className="text-2xl font-extrabold text-gray-900">
            ₹{totalSpent.toLocaleString("en-IN")}
          </p>
        </div>
        <div className="bg-white border border-gray-100 rounded-2xl p-5">
          <p className="text-xs font-semibold text-gray-400 tracking-wide mb-2">PENDING PAYMENTS</p>
          <p className="text-2xl font-extrabold text-orange-600">{pendingCount}</p>
        </div>
      </div>

      {/* Search + filters */}
      <div className="bg-white border border-gray-100 rounded-2xl p-4 mb-2">
        <div className="flex items-center gap-2 bg-gray-50 border border-gray-200 rounded-xl px-4 py-2.5 mb-4">
          <Search className="w-4 h-4 text-gray-400" />
          <input
            value={query}
            onChange={(e) => setQuery(e.target.value)}
            placeholder="Search transactions..."
            className="w-full bg-transparent text-sm focus:outline-none"
          />
        </div>

        <div className="flex flex-wrap gap-2">
          {filters.map((f) => {
            const isActive = activeFilter === f;
            return (
              <button
                key={f}
                type="button"
                onClick={() => setActiveFilter(f)}
                className={`text-sm font-medium px-4 py-1.5 rounded-full border transition ${
                  isActive
                    ? "bg-indigo-600 border-indigo-600 text-white"
                    : "bg-white border-gray-200 text-gray-700 hover:border-indigo-300"
                }`}
              >
                {f}
              </button>
            );
          })}
        </div>
      </div>

      {/* Transaction history */}
      <div className="bg-white border border-gray-100 rounded-2xl p-6">
        <h2 className="font-bold text-gray-900 mb-2">Transaction History</h2>
        {filtered.length > 0 ? (
          <div>
            {filtered.map((txn) => (
              <TransactionRow key={txn.id} txn={txn} />
            ))}
          </div>
        ) : (
          <div className="h-32 flex items-center justify-center text-gray-400">
            No transactions match your search.
          </div>
        )}
      </div>

      {showAddMoney && (
        <AddMoneyModal
          onClose={() => setShowAddMoney(false)}
          onConfirm={handleConfirmAddMoney}
        />
      )}
    </div>
  );
}